<div class="p-5 text-center">
    <h3>We will keep you informed of any updates regarding order #<strong>{{this.OrderId}}</strong></h3>
</div>
